import React, { useState } from "react";
import closeIcon from "../../assets/images/imageIcon/img_close.svg";
import { Input } from "components";
import { ClipLoader } from "react-spinners";
import { getImidServiceUrl } from "utils/api-util";

const CriticalPeriodModal = ({ closeModal }) => {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [tariff, setTariff] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [isSuccessful, setIsSuccessful] = useState(false);

  const token = window.localStorage.getItem("token");
  const baseUrl = getImidServiceUrl();

  const url = `${baseUrl}/`;

  const formatDateToLocalInput = (date) => {
    if (!date) return "";
    // const dt = new Date(date);
    // return dt.toISOString().slice(0, 16); // Remove seconds & timezone (`.000Z`)
  };

  const handleStartTimeChange = (e) => {
    const localTime = new Date(e.target.value); // Local time from input
    const utcTime = new Date(
      localTime.getTime() - localTime.getTimezoneOffset() * 60000
    ); // Convert local time to UTC

    const time = localTime.setHours(
      localTime.getHours() + localTime.getTimezoneOffset() / 60
    );
    let d = new Date(time); // The 0 there is the key, which sets the date to the epoch
    setStartTime(d.toLocaleString()); // Store in UTC format

    if (endTime && utcTime < new Date(startTime)) {
      setError("End time cannot be earlier than start time.");
    } else {
      setError("");
    }
  };

  const handleEndTimeChange = (e) => {
    const localTime = new Date(e.target.value); // Local time from input
    const utcTime = new Date(
      localTime.getTime() - localTime.getTimezoneOffset() * 60000
    ); // Convert local time to UTC
    const time = localTime.setHours(
      localTime.getHours() + localTime.getTimezoneOffset() / 60
    );
    let d = new Date(time);
    setEndTime(d.toLocaleString()); // Store in UTC format

    if (startTime && utcTime > new Date(endTime)) {
      setError("End time cannot be earlier than start time.");
    } else {
      setError("");
    }
  };

  const data = {
    startTime,
    endTime,
    tariff,
    city,
    zipCode,
  };

  //   send data to server
  const submitData = async () => {
    if (error) return; // Prevent submission if there's an error
    // console.log(data);

    if (!startTime || !endTime || !tariff || !city || !zipCode) {
      setMsg("Please fill in all fields before submitting.");
      return;
    }
    setMsg("");
    setError("");
    setIsLoading(true);
    setIsSuccessful(false);
    try {
      const response = await fetch("https://example.com/api/critical-period", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to send data");
      }

      const responseData = await response.json();
      console.log("Server Response:", responseData);
      setMsg("You have successfully created a critical period");
      setIsSuccessful(true);
    } catch (error) {
      setMsg("Something went wrong");
      setIsSuccessful(false);
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center h-screen w-screen justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white relative rounded-lg shadow-lg p-6 w-full max-w-md">
        <div
          className="mb-2 cursor-pointer w-fit absolute top-5 right-5"
          onClick={closeModal}
        >
          <img className="w-[20px]" src={closeIcon} alt="close" />
        </div>
        <h2 className="text-xl font-extrabold mb-4 text-center text-[#4F4F4F]">
          Set Critical Period
        </h2>

        <div>
          {/* Start Period */}
          <div className="w-full justify-between flex">
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="startTime"
              value={formatDateToLocalInput(startTime)}
              onChange={handleStartTimeChange}
              labelText="Start Period"
              type="datetime-local"
              placeholder="Select start time"
            />
          </div>

          {/* End Period */}
          <div className="my-3 w-full justify-between flex">
            <Input
              wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
              className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
              labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
              name="endTime"
              value={formatDateToLocalInput(endTime)}
              onChange={handleEndTimeChange}
              labelText="End Period"
              type="datetime-local"
              placeholder="Select end time"
            />
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500 text-[12px] mb-3">{error}</p>}

          {/* Tariff Input */}
          <Input
            wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mb-5 px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
            className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
            labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
            name="tariff"
            value={tariff}
            onChange={(e) => setTariff(e.target.value)}
            labelText="Tariff"
            required={true}
            type="number"
            // onBlur={handleBlur}
            placeholder="0"
          />
          <Input
            wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mb-5 px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
            className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
            labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
            name="tariff"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            labelText="Province/City"
            type="text"
            // onBlur={handleBlur}
            placeholder=""
          />
          <Input
            wrapClassName="bg-gray_100 border-[1px] border-light_blue_800 border-solid flex flex-row font-montserrat h-[66px] md:h-[auto] items-center justify-start mb-5 px-[20px] py-[11px] rounded-[10px] sm:w-[100%] w-full"
            className="font-semibold p-[0] placeholder:text-gray_600 text-[16px] text-gray_600 text-left w-[100%]"
            labelClass="relative text-sm text-gray-500 dark:text-gray-400 peer-focus:dark:text-blue-500"
            name="tariff"
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
            labelText="Zip Code"
            type="text"
            // onBlur={handleBlur}
            placeholder=""
          />

          {/* Submit Button */}
          <button
            className={`px-4 w-full py-4 rounded text-[#fff] ${
              error
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#0074bb] hover:bg-[#0054bb]"
            }`}
            onClick={submitData}
            disabled={!!error}
          >
            {isLoading ? (
              <ClipLoader color="#fff" size={20} />
            ) : (
              "Set Critical Period"
            )}
          </button>
          <p
            className={`${
              isSuccessful ? "text-green-500" : "text-red-500"
            } text-[12px] my-3`}
          >
            {msg}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CriticalPeriodModal;
